import React, {useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {CgDanger} from "@react-icons/all-files/cg/CgDanger";


export default function ResetPassword() {

    const navigate = useNavigate();
    const location = useLocation();
    const [errorTxt, setErrorTxt] = useState();
    const [errorMsg, setErrorMsg] = useState("");
    const [errorMsgShow, setErrorMsgShow] = useState(false);

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        const response = (await fetch(
            `${process.env.REACT_APP_HOST_BASE_URL}/reset/password`,
            {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    emailOrPhone: evt.target.emailOrPhone.value,
                    confirmCode: evt.target.confirmCode.value,
                    newPassword: evt.target.newPassword.value,
                }),
            }
        ));
        if (response.ok) {
            navigate("/");
        } else {
            await response.text().then(value => {
                setErrorTxt(value);
                setErrorMsg(value);
                console.log(value)
            });
            setErrorMsgShow(true);
            setTimeout(() => {
                setErrorMsgShow(false);
            }, 10000);
            // navigate("/error", {
            //     state: {
            //         status: response.status,
            //         message: errorTxt ? errorTxt : "Error",
            //     },
            // });
        }
    };


    return (
        <>
            <div className="flex flex-col justify-center min-h-full py-12 sm:px-6 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                    <img
                        className="w-auto h-12 mx-auto"
                        src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg"
                        alt="Workflow"
                    />
                    <h2 className="mt-6 text-3xl font-extrabold text-center text-gray-900">
                        Construction
                    </h2>
                    {errorMsgShow ?
                        <div className="flex items-top rounded-xl bg-red-500 text-white text-sm font-bold px-4 py-1"
                             role="alert">
                            <CgDanger className="text-white h-9 w-9 mr-3 mt-3 mb-3"/>
                            <p className="mt-3">{errorMsg}</p>
                        </div>
                        : <div></div>
                    }
                </div>

                <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                    <div className="px-4 py-8 bg-white shadow sm:rounded-lg sm:px-10">
                        <form className="space-y-6" onSubmit={handleSubmit}>
                            <div>
                                <label
                                    htmlFor="confirmCode"
                                    className="block text-base font-medium text-gray-700"
                                >
                                    Код подтверждения
                                </label>
                                <div className="mt-3">
                                    <input
                                        id="confirmCode"
                                        name="confirmCode"
                                        type="number"
                                        autoComplete="confirmCode"
                                        required
                                        className="block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                    <div className="mt-2 text-xs"><span>Введите код, полученный на ваш телефон или адрес электронной почты.</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <label
                                    htmlFor="emailOrPhone"
                                    className="block text-base font-medium text-gray-700"
                                >
                                    Введите эл.адресы или номер телефона
                                </label>
                                <div className="mt-3">
                                    <input
                                        id="emailOrPhone"
                                        name="emailOrPhone"
                                        type="text"
                                        autoComplete="emailOrPhone"
                                        defaultValue={location.state?.emailOrPhone}
                                        required
                                        className="block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                    <div className="mt-2 text-xs"><span>Требуется ваш основной адрес электронной почты или основной номер телефона.</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <label
                                    htmlFor="newPassword"
                                    className="block text-base font-medium text-gray-700"
                                >
                                    Новый пароль
                                </label>
                                <div className="mt-3">
                                    <input
                                        id="newPassword"
                                        name="newPassword"
                                        type="text"
                                        autoComplete="newPassword"
                                        required
                                        className="block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    />
                                    <div className="mt-2 text-xs"><span>Введите новый пароль для использования программы.</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <button
                                    type="submit"
                                    className="flex justify-center w-full px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                    Подтвердить
                                </button>
                            </div>
                        </form>

                        <div className="mt-10">
                            <div className="w-full">
                                <p className="text-base text-center">
                                    Логин и пароль уже есть?
                                    <span>
                                        <a
                                            onClick={() => {
                                                navigate("/")
                                            }}
                                            className="ml-1 font-medium text-indigo-600 hover:text-indigo-500"
                                        >Войти</a>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
